import { taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends, objectDestructuringEmpty as _objectDestructuringEmpty, slicedToArray as _slicedToArray, objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, useRef, useState, useEffect, useMemo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';
import _Button from '../Button/index.js';
import { toKebabCase } from '../../utils/textUtils.js';

var _excluded = ["iconColor", "iconName", "iconSize", "position", "theme", "ariaLabelText", "toolText", "toolTextWidth", "showOnHover", "bodyText", "disabled", "_width", "_height", "showToolTipText"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function DisplayIcon(props) {
  var bodyText = props.bodyText,
    iconColor = props.iconColor,
    iconName = props.iconName,
    iconSize = props.iconSize;
  if (bodyText) {
    return /*#__PURE__*/React.createElement("div", null, " ", bodyText);
  }
  return /*#__PURE__*/React.createElement(_Icon, {
    color: iconColor,
    name: iconName,
    size: iconSize
  });
}
var StyledToolTipContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n"])));
var StyledToolTipText = styled('span')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: ", ";\n  position: absolute;\n  background-color: ", ";\n  border: ", ";\n  color: ", ";\n  text-align: left;\n  font-size: 0.875rem;\n  padding: 0.5rem 0.5rem 0.5rem 0.5rem;\n  border-radius: 2px;\n  z-index: 99;\n  outline: none;\n  opacity: 1;\n  left: ", ";\n  bottom: ", ";\n  top: ", ";\n  transform: ", ";\n  max-width: ", ";\n  width: ", ";\n  pointer-events: none;\n\n  &:before {\n    bottom: ", ";\n    border-color: transparent transparent\n      ", " transparent;\n    border-width: 8px;\n    border-style: solid;\n    content: '';\n    left: ", ";\n    margin-top: 10px;\n    position: absolute;\n    transform: ", ";\n  }\n  &:after {\n    bottom: ", ";\n    top: ", ";\n    border-color: transparent transparent\n      ", " transparent;\n    border-width: 6px;\n    border-style: solid;\n    content: '';\n    left: ", ";\n    margin-top: 10px;\n    position: absolute;\n    transform: ", ";\n  }\n  @media (max-width: 500px) {\n    inline-size: ", ";\n  }\n"])), function (_ref) {
  var showToolTip = _ref.showToolTip;
  return showToolTip ? 'block' : 'none';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.secondaryLightest;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.palette.secondaryLighter, " solid 2px");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.black;
}, function (_ref5) {
  var position = _ref5.position;
  return position === 'bottom' || position === 'top' ? '50%' : '';
}, function (_ref6) {
  var position = _ref6.position;
  return position === 'bottom' ? 'auto' : position === 'top' ? '120%' : 'auto';
}, function (_ref7) {
  var position = _ref7.position;
  return position === 'top' ? 'auto' : position === 'bottom' ? '120%' : '-10px';
}, function (_ref8) {
  var position = _ref8.position,
    width = _ref8.width,
    height = _ref8.height;
  return position === 'left' ? "translateX(calc(-100% - (".concat(height, "px/4)))") : position === 'right' ? "translateX(calc(".concat(height, "px + 10px))") : 'translateX(-50%)';
}, function (_ref9) {
  var toolTextWidth = _ref9.toolTextWidth;
  return toolTextWidth ? 'none' : 'calc(50em / 2)';
}, function (_ref10) {
  var toolTextWidth = _ref10.toolTextWidth;
  return toolTextWidth ? toolTextWidth : 'max-content';
}, function (_ref11) {
  var position = _ref11.position;
  return position === 'bottom' ? '100%' : position === 'top' && 0;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.secondaryLighter;
}, function (_ref13) {
  var position = _ref13.position;
  return position === 'top' || position === 'bottom' ? '50%' : position === 'left' && '100%';
}, function (_ref14) {
  var position = _ref14.position;
  return position === 'bottom' ? 'translateX(-50%)' : position === 'top' ? 'translate(-50%, 100%) rotate(180deg)' : position === 'right' ? 'translate(-150%, -60%) rotate(270deg)' : 'translateY(-50%) rotate(90deg)';
}, function (_ref15) {
  var position = _ref15.position;
  return position === 'bottom' ? '100%' : position === 'top' && 0;
}, function (_ref16) {
  var position = _ref16.position;
  return (position === 'left' || position === 'right') && '2px';
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.secondaryLightest;
}, function (_ref18) {
  var position = _ref18.position;
  return position === 'top' || position === 'bottom' ? '50%' : position === 'left' ? '100%' : '0%';
}, function (_ref19) {
  var position = _ref19.position;
  return position === 'bottom' ? 'translateX(-50%)' : position === 'top' ? 'translate(-50%, 100%) rotate(180deg)' : position === 'right' ? 'translate(-100%,-12%) rotate(270deg)' : 'translateX(-1px) rotate(90deg)';
}, function (_ref20) {
  var toolTextWidth = _ref20.toolTextWidth;
  return toolTextWidth ? toolTextWidth : 'calc(15em / 2)';
});
var StyledToolTip = styled('button')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  display: inline-block;\n  opacity: ", ";\n  align-content: center;\n  cursor: pointer;\n  &:hover + ", " {\n    display: ", ";\n  }\n  &:hover {\n    cursor: ", ";\n  }\n"])), function (_ref21) {
  var disabled = _ref21.disabled;
  return disabled ? '0.3' : '1';
}, StyledToolTipText, function (_ref22) {
  var disabled = _ref22.disabled,
    showOnHover = _ref22.showOnHover,
    showToolTip = _ref22.showToolTip;
  return disabled || !showOnHover && !showToolTip ? 'none' : 'block';
}, function (_ref23) {
  var disabled = _ref23.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var StyledExitButton = styled(_Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: none\n  pointer-events: auto;\n  cursor: pointer;\n  z-index: 99999;\n  position: absolute;\n  top: 0;\n  right: 0;\n"])));
var ToolTip = function ToolTip(_ref24) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref24), _ref24));
  var tipRef = useRef(null);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  useEffect(function () {
    setWidth(tipRef && tipRef.current && tipRef.current.offsetWidth || 0);
    setHeight(tipRef && tipRef.current && tipRef.current.offsetHeight || 0);
  }, []);
  var iconColor = props.iconColor,
    _props$iconName = props.iconName,
    iconName = _props$iconName === void 0 ? 'info' : _props$iconName,
    _props$iconSize = props.iconSize,
    iconSize = _props$iconSize === void 0 ? 'small' : _props$iconSize,
    _props$position = props.position,
    position = _props$position === void 0 ? 'bottom' : _props$position,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? themes["default"] : _props$theme,
    _props$ariaLabelText = props.ariaLabelText,
    ariaLabelText = _props$ariaLabelText === void 0 ? 'tooltip' : _props$ariaLabelText,
    toolText = props.toolText,
    toolTextWidth = props.toolTextWidth,
    _props$showOnHover = props.showOnHover,
    showOnHover = _props$showOnHover === void 0 ? true : _props$showOnHover,
    bodyText = props.bodyText,
    disabled = props.disabled,
    _props$_width = props._width,
    _width = _props$_width === void 0 ? width : _props$_width,
    _props$_height = props._height,
    _height = _props$_height === void 0 ? height : _props$_height,
    showToolTipText = props.showToolTipText,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showToolTip = _useState6[0],
    setShowToolTip = _useState6[1];
  var handleOnBlur = function handleOnBlur() {
    if (!showOnHover) {
      setShowToolTip(showToolTip ? true : false);
    }
    if (showToolTip) {
      setShowToolTip(false);
    }
  };
  var handleOnClick = function handleOnClick(e) {
    e.preventDefault();
    setShowToolTip(!showToolTip);
  };
  var ariaDescribedBy = useMemo(function () {
    return "".concat(toKebabCase(ariaLabelText), "-desc");
  }, [ariaLabelText]);
  return /*#__PURE__*/React.createElement(StyledToolTipContainer, null, /*#__PURE__*/React.createElement(StyledToolTip, {
    alt: toolText,
    "aria-describedby": ariaDescribedBy,
    "aria-label": ariaLabelText,
    className: "toolTip",
    disabled: disabled,
    onBlur: handleOnBlur,
    onClick: handleOnClick,
    ref: tipRef,
    showOnHover: showOnHover,
    showToolTip: showToolTip,
    tabIndex: disabled ? -1 : 0,
    theme: theme,
    type: 'button'
  }, /*#__PURE__*/React.createElement(DisplayIcon, {
    bodyText: bodyText,
    iconColor: iconColor,
    iconName: iconName,
    iconSize: iconSize
  })), /*#__PURE__*/React.createElement(StyledToolTipText, _extends({}, rest, {
    className: "toolTipText",
    height: _height,
    id: ariaDescribedBy,
    position: position,
    role: 'tooltip',
    showOnHover: showOnHover,
    showToolTip: showToolTip,
    theme: theme,
    toolTextWidth: toolTextWidth,
    width: _width
  }), !showOnHover && /*#__PURE__*/React.createElement(StyledExitButton, {
    "data-testid": 'tooltip-exit-button',
    onClick: function onClick() {
      return setShowToolTip(false);
    },
    size: 'small'
  }, /*#__PURE__*/React.createElement(_Icon, {
    "aria-controls": ariaDescribedBy,
    "aria-label": "close",
    color: 'grayDarker',
    name: 'close',
    size: 'small'
  })), /*#__PURE__*/React.createElement("div", {
    "data-testid": 'tooltip-text'
  }, toolText)));
};
var _ToolTip = withDefaultTheme(/*#__PURE__*/memo(ToolTip));

export default _ToolTip;
